(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-notify-me"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.dataset.bdNotifyReady === 'true') return;
    document.documentElement.dataset.bdNotifyReady = 'true';
    const companyId = 'XajYdn';

    const dialog = () => document.querySelector('[data-bd-notify-dialog]');
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bd-notify-trigger]');
      if (trigger) {
        event.preventDefault();
        const modal = dialog();
        if (!modal) return;
        modal.querySelector('[data-bd-notify-product]').textContent = trigger.dataset.productTitle || '';
        modal.querySelector('[data-bd-notify-variant]').value = trigger.dataset.variantId || '';
        const status = modal.querySelector('[data-bd-notify-status]');
        status.textContent = '';
        status.classList.remove('is-error');
        modal.showModal();
        modal.querySelector('input[type="email"]')?.focus();
        return;
      }
      if (event.target.closest('[data-bd-notify-close]')) dialog()?.close();
      if (event.target.matches('[data-bd-notify-dialog]')) event.target.close();
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-bd-notify-form]');
      if (!form) return;
      event.preventDefault();
      const email = form.elements.email.value.trim();
      const variantId = form.elements.variant_id.value;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-bd-notify-status]');
      if (!email || !variantId) return;
      button.disabled = true;
      status.textContent = '';
      status.classList.remove('is-error');
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
              }
            }
          })
        });
        if (!response.ok) throw new Error('Subscription failed');
        form.reset();
        status.textContent = form.closest('[data-bd-notify-dialog]')?.dataset.successMessage || 'You are on the list.';
      } catch (error) {
        status.textContent = form.closest('[data-bd-notify-dialog]')?.dataset.errorMessage || 'Unable to subscribe right now.';
        status.classList.add('is-error');
      } finally {
        button.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
